import {z} from 'zod';

import {mechanicFiltersSchema} from './MechanicFiltersSchema';

export const mechanicLabourByMonthSchema = z.object({
  month: z.string(),
  sellingPrice: z.number(),
  mechanicSoldTime: z.number(),
  margin: z.number(),
  mechanicCost: z.number(),
  discount: z.number(),
});

export type MechanicLabourByMonth = z.infer<typeof mechanicLabourByMonthSchema>;

export const mechanicLabourSummarySchema = mechanicLabourByMonthSchema
  .omit({month: true})
  .extend({averageMarginPercent: z.number()});

export type MechanicLabourSummary = z.infer<typeof mechanicLabourSummarySchema>;

export const mechanicLabourByMonthResponseSchema = z.object({
  data: z.array(mechanicLabourByMonthSchema),
  summary: mechanicLabourSummarySchema,
  filters: mechanicFiltersSchema,
});

export type MechanicLabourByMonthResponse = z.infer<typeof mechanicLabourByMonthResponseSchema>;
